import { getAttorneyInvoiceAmount } from "../../utils/attorneyInvoicePricing";
import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { AttorneyPendingBillingUser, exportAtorneyInvoice } from '../../api/server';
import moment from 'moment';
import { ThreeDots } from 'react-loader-spinner';
import { toast } from 'react-toastify';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import DashBoardSidebar from '../../layouts/dashBoard-Sidebar';
import DashboardNavbar from '../../layouts/dashboardNavbar';
import { FaArrowLeft } from 'react-icons/fa';

const InvoiceModal = ({ }) => {
    const [response, setResponse] = useState({});
    const [loadingPdf, setLoadingPdf] = useState(false);
    const [serviceFee, setServiceFee] = useState(3);
    const [totalCourses, setTotalCourses] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    // const [searchParams] = useSearchParams();
    const location = useLocation();
    // const course = searchParams.get("course");
    const { course } = useParams();
    //    const email = location.state?.email;
    const attorneyData = location.state?.attorneyData;
    console.log("course>>>>>", course, attorneyData)
    const fetchData = async () => {
        const payload = {
            // course: course,
            // course: attorneyData?.course == "CC,DE" ?  "both" : attorneyData?.course == "CC" ? "first" : "second" ,
            course: course,
            email: attorneyData.email,
            code: attorneyData.attorneyCode
        };
        setLoading(true);
        const data = await AttorneyPendingBillingUser(payload);
        if (data?.data?.message === "Success") {
            const modifiedData = {};
            Object.entries(data?.data?.pendingBillingUserList || {}).forEach(([key, arr]) => {
                modifiedData[key] = arr.map((item) => ({
                    ...item,
                    amount: getAttorneyInvoiceAmount(item)
                }));
            });
            setResponse(modifiedData);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (response) {
            let total = 0;
            Object.values(response).forEach((arr) => {
                arr.forEach((r) => {
                    total += parseFloat(r.amount || 0);
                });
            });
            setTotalCourses(total);
            const feeAmount = (parseFloat(serviceFee || 0) / 100) * total;
            setGrandTotal(total + feeAmount);
        }
    }, [response, serviceFee]);

    const handleAmountChange = (courseKey, index, value) => {
        const updated = { ...response };
        updated[courseKey][index].amount = parseFloat(value || 0);
        setResponse(updated);
    };

    const handleExport = async () => {
        const invoiceCourse = attorneyData?.course == "CC,DE" ? "both" : attorneyData?.course == "CC" ? "first" : "second";
        const courseKeys = invoiceCourse === "both" ? ["CC", "DE"] : [invoiceCourse === "first" ? "CC" : "DE"];
        const students = {};
        courseKeys.forEach((courseKey) => {
            students[courseKey] = {
                data: (response[courseKey] || []).map((student) => ({
                    id: student.id,
                    name: student.name,
                    email: student.email,
                    enrolDate: student.enrolDate,
                    amount: `$${parseFloat(student.amount || 0).toFixed(2)}`
                }))
            };
        });

        const payload = {
            attorneyId: attorneyData?.id,
            course: invoiceCourse,
            attorneyName: attorneyData?.name,
            totalCourse: `$${Number(totalCourses)?.toFixed(2)}`,
            serviceAmount: `$${((totalCourses * (serviceFee || 0)) / 100).toFixed(2)}`,
            servicePercentage: `${serviceFee}`,
            total: `$${grandTotal.toFixed(2)}`,
            students // grouped by course
        };
        console.log("Payload:", payload);

        setLoadingPdf(true);
        try {
            const res = await exportAtorneyInvoice(payload);
            if (res?.data?.success) {
                setLoadingPdf(false);
                toast.success("Invoice Generated Successfully!");
                const link = res?.data?.data;
                if (link) {
                    const anchor = document.createElement('a');
                    anchor.href = link;
                    anchor.setAttribute('download', 'invoice.pdf');
                    anchor.setAttribute('target', '_blank');
                    document.body.appendChild(anchor);
                    anchor.click();
                    document.body.removeChild(anchor);
                }
                // setShowModal(false);
                // fetchParentData(true);
                // navigate(`?show=false`)
                navigate(-1);
            } else {
                setLoadingPdf(false);
                toast.error("There is some error");
            }
        } catch (error) {
            console.error("Export error:", error);
            setLoadingPdf(false);
            toast.error("Something went wrong!");
        }
    };

    return (
        // <Modal fullscreen show={showModal} onHide={() => setShowModal(false)}>
        //     <Modal.Body style={{ padding: '2rem 3rem', position: "relative" }}>
        //         {/* Cancel button at top-right */}
        //         <button
        //             onClick={() => setShowModal(false)}
        //             style={{
        //                 position: "absolute",
        //                 top: "10px",
        //                 right: "15px",
        //                 background: "transparent",
        //                 border: "none",
        //                 fontSize: "24px",
        //                 cursor: "pointer",
        //                 zIndex: 10,
        //             }}
        //         >
        //             ✖
        //         </button>


        //     </Modal.Body>
        // </Modal>
        <div className="wrapper">
            <DashBoardSidebar />
            <div id="content">
                <DashboardNavbar />
                <section className="manage-students language_wrap">
                    <div className='px-2'>
                        <div>

                            {/*                         
                        <button className="btn_brnd"  onClick={()=>navigate(-1)} style={{ padding: '14px 24px' }}>
                               Go Back
                            </button> */}
                            <button
                                onClick={() => navigate(-1)}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    backgroundColor: "#4e9c4b",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "30px",
                                    padding: "10px 20px",
                                    fontSize: "20px",
                                    fontWeight: "500",
                                    cursor: "pointer",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                    transition: "all 0.2s ease-in-out",
                                }}
                                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#3c7d3a")}
                                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#4e9c4b")}
                            >
                                <FaArrowLeft style={{ fontSize: "16px" }} />
                                {/* Go Back */}
                            </button>
                            <div
                                className="mb-2"
                                style={{ fontSize: '22px', fontWeight: '600', textAlign: 'center' }}
                            >
                                {attorneyData?.name} Invoice Summary
                            </div>

                        </div>
                        {loading ? (
                            <div
                                style={{
                                    height: '150px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            >
                                <ThreeDots height="20" width="52" color="#4fa94d" />
                            </div>
                        ) : (
                            response &&
                            Object.entries(response).map(([courseKey, students]) =>
                                students.length > 0 ? (
                                    <div key={courseKey} style={{ marginBottom: '40px' }}>
                                        <h5 style={{ fontWeight: '600', marginBottom: '25px' }}>
                                            {courseKey} Students
                                        </h5>
                                        <div
                                            style={{
                                                maxHeight: '400px',
                                                overflowY: 'auto',
                                                // border: '1px solid #ddd',
                                                borderRadius: '10px'
                                            }}
                                        >
                                            <table className="table mb-0 no-border">
                                                <thead>
                                                    <tr>
                                                        <th style={{ position: 'sticky', top: 0, backgroundColor: '#EFEFEF' }}>
                                                            Student Name
                                                        </th>
                                                        <th style={{ position: 'sticky', top: 0, backgroundColor: '#EFEFEF' }}>
                                                            Email
                                                        </th>
                                                        <th style={{ position: 'sticky', top: 0, backgroundColor: '#EFEFEF' }}>
                                                            Enrolled Date
                                                        </th>
                                                        <th style={{ position: 'sticky', top: 0, backgroundColor: '#EFEFEF' }}>
                                                            Amount
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {students.map((r, idx) => (
                                                        <tr key={idx} >
                                                            <td style={{ verticalAlign: 'middle', padding: '8px 10px' }}>{r.name}</td>
                                                            <td style={{ verticalAlign: 'middle', padding: '8px 10px' }}>{r.email}</td>
                                                            <td style={{ verticalAlign: 'middle', padding: '8px 10px' }}>
                                                                {moment(r.enrolDate).format("MMMM Do YYYY")}
                                                            </td>
                                                            <td style={{ verticalAlign: 'middle', padding: '8px 10px' }}>
                                                                <input
                                                                    type="text"
                                                                    value={r.amount}
                                                                    onChange={(e) => handleAmountChange(courseKey, idx, e.target.value)}
                                                                    className="form-control form-control-sm"
                                                                    style={{
                                                                        width: '80px',
                                                                        height: '20px',
                                                                        textAlign: 'center',

                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}

                                                    {/* Subtotal row */}
                                                    {/* <tr style={{ backgroundColor: '#f5f5f5', fontWeight: '600' }}>
                                                <td colSpan={3} style={{ textAlign: 'right', paddingRight: '15px' }}>
                                                    Total:
                                                </td>
                                                <td>
                                                    ${students.reduce((sum, s) => sum + parseFloat(s.amount || 0), 0).toFixed(2)}
                                                </td>
                                            </tr> */}
                                                </tbody>
                                            </table>
                                        </div>
                                        {/* <div
          className="d-flex justify-content-end mt-2 px-5"
          style={{ fontWeight: '700', fontSize: '18px' }}
        >
        
          <span>
          <span style={{marginRight:'10px'}}> Total Amount:</span>

            ${students.reduce((sum, s) => sum + parseFloat(s.amount || 0), 0).toFixed(2)}
          </span>
        </div> */}
                                    </div>
                                ) : null
                            )
                        )}

                        {/* Summary Section */}
                        {
                            !loading &&
                            <>
                                <div className="px-2 py-3" style={{ fontSize: '14px', marginTop: '25px' }}>
                                    <div className="d-flex justify-content-between mb-2">
                                        <strong>Total Courses:</strong>
                                        <span>${totalCourses}</span>
                                    </div>
                                    <hr />
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="d-flex align-items-center">
                                            <strong>Service Fee:</strong>
                                            <input
                                                type="text"
                                                value={serviceFee}
                                                onChange={(e) => setServiceFee(parseFloat(e.target.value || 0))}
                                                className="form-control form-control-sm"
                                                style={{ width: '50px', height: '25px', marginLeft: '10px', marginRight: '10px' }}
                                            />
                                            <span>%</span>
                                        </div>
                                        <div>${((totalCourses * (serviceFee || 0)) / 100).toFixed(2)}</div>
                                    </div>
                                    <hr />
                                    <div className="d-flex justify-content-between mt-3" style={{ fontSize: '18px', fontWeight: '600' }}>
                                        <span>Total:</span>
                                        <span>${grandTotal.toFixed(2)}</span>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center mt-3">

                                    <button className="btn_brnd" disabled={loadingPdf} onClick={handleExport} style={{ padding: '14px 24px' }}>
                                        {loadingPdf ? (
                                            <ThreeDots height="20" width="120" color="#4fa94d" />
                                        ) : (
                                            "Export Invoice"
                                        )}
                                    </button>
                                </div>
                            </>
                        }

                    </div>
                </section>
            </div>
        </div>
    );
};

export default InvoiceModal;
